export default function getAgentStateByType(agent: connect.Agent, type: connect.AgentStateType) {
    const agentStates = agent.getAgentStates();
    const state = agentStates.find((state) => state.type === type);
    if (!state) throw new Error(`No ${type} agent states are available`);
    return state;
}
